import React from 'react';
import { Users, Globe, Star, Shield } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const CompactTrustStats = () => {
  const { t } = useLanguage();

  const stats = [
    {
      icon: Users,
      value: '50,000+',
      label: t('home.clientsWorldwide') || 'Clients Worldwide',
      color: 'text-blue-500'
    },
    {
      icon: Globe,
      value: '150+',
      label: t('home.countries') || 'Countries',
      color: 'text-green-500'
    },
    {
      icon: Star,
      value: '4.8/5',
      label: t('home.averageRating') || 'Average Rating',
      color: 'text-yellow-500'
    },
    {
      icon: Shield,
      value: '5,000+',
      label: t('home.verifiedProfessionals') || 'Verified Professionals',
      color: 'text-purple-500'
    }
  ];

  return (
    <section className="py-8 bg-muted/50 border-y">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="flex flex-col items-center text-center">
                <Icon className={`h-6 w-6 mb-2 ${stat.color}`} />
                <div className="text-2xl md:text-3xl font-bold mb-1">{stat.value}</div>
                <div className="text-sm text-muted-foreground">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CompactTrustStats;
